export default __webpack_public_path__ + "imgs/recreational.e584a76941cc7b156c5c7388892bc78c.svg";